import { toast } from "@cobee/cobee-ui";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import rejectBenefitRequest from "v2/domain/benefitRequest/useCases/rejectBenefitRequest";

type Params = {
  companyId: string;
  requestId: string;
  reason: string;
};

export default function useRejectBenefitRequest() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation<void, Error, Params>(
    ({ companyId, requestId, reason }) => {
      return rejectBenefitRequest({ companyId, requestId, reason });
    },
    {
      onSuccess: (_data, variables) => {
        toast.show(t("v2.common.the-request-has-been-processed"), {
          type: "success",
          position: "top-right",
        });
        queryClient.invalidateQueries([
          "companyBenefitRequestDetail",
          `${variables.companyId}/${variables.requestId}`,
        ]);
      },
      onError: (_error, variables) => {
        queryClient.invalidateQueries([
          "companyBenefitRequestDetail",
          `${variables.companyId}/${variables.requestId}`,
        ]);
      },
    }
  );
}
